import { Factory, Building2, Building, Cog } from "lucide-react";
import { motion } from "framer-motion";

const SuccessStories = () => {
  const stories = [
    {
      title: "GCM PERÚ",
      description:
        "Reducción del 49% en la factura eléctrica mediante diagnóstico energético y control de demanda.",
      icon: <Factory className="h-6 w-6 text-sergen-700" />,
      savings: "49%",
      image: "/lovable-uploads/0002.jpg",
    },
    {
      title: "ULTRAFRÍO",
      description:
        "Optimización del control de demanda logrando una reducción del 36% en costos eléctricos en planta.",
      icon: <Building2 className="h-6 w-6 text-sergen-700" />,
      savings: "36%",
      image: "/lovable-uploads/0006.jpg",
    },
    {
      title: "MONT BLANC EXPORT",
      description:
        "Sistema automatizado que redujo el gasto eléctrico en 21% y mejoró la estabilidad operativa.",
      icon: <Building className="h-6 w-6 text-sergen-700" />,
      savings: "21%",
      image: "/lovable-uploads/0004.jpg",
    },
    {
      title: "YOFRI S.A.C.",
      description:
        "Estrategia integral de eficiencia que redujo los costos eléctricos en 28% y mejoró la estabilidad operativa.",
      icon: <Cog className="h-6 w-6 text-sergen-700" />,
      savings: "28%",
      image: "/lovable-uploads/0008.jpg",
    },
  ];

  const loopedStories = [...stories, ...stories, ...stories];

  return (
    <section className="relative overflow-hidden bg-[#f3f1ed] py-20">

      {/* 🔥 LUZ AMBIENTAL */}
      <motion.div
        className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(249,224,191,0.15),transparent_70%)]"
        animate={{ x: ["-50%", "50%"] }}
        transition={{ repeat: Infinity, duration: 30, ease: "linear" }}
        style={{ mixBlendMode: "soft-light" }}
      />

      {/* 🔵 ENCABEZADO */}
      <div className="relative z-10 text-center mb-12">
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900">
          Historias que iluminan la eficiencia
        </h2>
        <p className="mt-4 mx-auto max-w-3xl text-lg text-gray-700">
          Empresas que confiaron en SERGEN y transformaron su gestión energética en resultados reales.
        </p>
      </div>

      {/* 📱 MOBILE — versión ULTRA LIGERA */}
      <div className="md:hidden flex flex-col gap-6 px-6 relative z-10">

        {stories.map((story, i) => (
          <div
            key={i}
            className="bg-white rounded-2xl shadow-md overflow-hidden"
          >
            <img
              src={story.image}
              alt={story.title}
              className="w-full h-[200px] object-cover"
            />

            <div className="p-5 text-center">
              <div className="mb-2 flex justify-center">{story.icon}</div>
              <h3 className="text-lg font-bold text-sergen-700">{story.title}</h3>
              <p className="text-gray-600 text-sm my-2">{story.description}</p>

              <div className="inline-flex flex-col items-center justify-center rounded-lg bg-[#f9e0bf] px-4 py-2">
                <span className="text-xl font-black text-sergen-700">
                  {story.savings}
                </span>
                <span className="text-xs font-medium text-sergen-700">
                  Reducción en la factura eléctrica
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* 💻 DESKTOP — carrusel completo */}
      <div className="hidden md:block relative mx-auto max-w-[1440px] overflow-hidden z-10 mb-12">
        <motion.div
          className="flex gap-10"
          animate={{ x: ["0%", "-66.66%"] }}
          transition={{
            repeat: Infinity,
            duration: 20,
            ease: "linear",
          }}
        >
          {loopedStories.map((story, i) => (
            <div
              key={i}
              className="flex-shrink-0 w-[340px] bg-white rounded-2xl overflow-hidden relative hover:scale-[1.02] transition-transform duration-300"
              style={{
                boxShadow:
                  "0 0 25px 6px rgba(249,224,191,0.35), 0 6px 10px rgba(0,0,0,0.06)",
              }}
            >
              <div className="h-[220px] relative">
                <img
                  src={story.image}
                  alt={story.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent" />
              </div>

              <div className="p-6 text-center">
                <div className="mb-2 flex justify-center">{story.icon}</div>
                <h3 className="text-lg font-bold text-sergen-700">{story.title}</h3>
                <p className="text-gray-600 text-sm my-2">{story.description}</p>

                <div className="inline-flex flex-col items-center justify-center rounded-lg bg-[#f9e0bf] px-4 py-2">
                  <span className="text-xl font-black text-sergen-700">
                    {story.savings}
                  </span>
                  <span className="text-xs font-medium text-sergen-700">
                    Reducción en la factura eléctrica
                  </span>
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>

      {/* TEXTO FINAL */}
      <div className="relative z-10 text-center max-w-5xl mx-auto px-6 mt-2">
        <p className="text-lg md:text-xl text-gray-900 font-medium">
          Así como estas empresas, tu industria también puede convertir la eficiencia energética en una historia de éxito.
        </p>
      </div>

    </section>
  );
};

export default SuccessStories;
